import React, { useEffect, useState } from 'react'
import { ApiGetCallAuthKey, ApiPostCall } from '../../JS/Connector';
import { LogInSchoolID } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import { useNavigate } from 'react-router-dom';
import useConfig from '../../Hooks/useConfig';
import SettingBoxWrapper from './SettingBoxWrapper';
import AlertPopup from '../../Components/AlertPopup';

export default function IncreaseGrade({ setLoading, setNewAlerts }) {
    const { students } = useConfig();

    const [showIncreseGradePopup, setShowIncreaseGradePopup] = useState(false);
    const [archiveGrade, setArchiveGrade] = useState(1);
    const navigate = useNavigate();

    async function IncreaseGradeByOne() {
        const raw = JSON.stringify({ schoolId: LogInSchoolID, archiveGrade: archiveGrade });

        setLoading(true);
        await ApiPostCall(`/settings/upgrade-grades`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={responseRs.msg} />);
                    setTimeout(() => {
                        navigate('/users');
                        setShowIncreaseGradePopup(false);
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    return (
        <>
            <SettingBoxWrapper
                BoxTitle={'Increase Grade'}
                BoxLabel={`This functionality allows you to effortlessly advance all your ${students} to the next grade level with just a single click. By selecting the "Increase Grade by One" option, you can seamlessly promote all your ${students} to the subsequent grade, ensuring a smooth transition for the upcoming academic year.`}
                labelCustomClass={'text-justify'}
            >
                <label className='SaveBtn mt-2' onClick={() => setShowIncreaseGradePopup(true)}>
                    Increase Grade by One
                </label>

            </SettingBoxWrapper>

            <AlertPopup
                img={'/images/greenInfo.svg'}
                headingtext={'Are you sure you want to increase the grade of all users/students?'}
                text={
                    <>
                        <input checked={archiveGrade == 1} type="checkbox" className="form-check-input mt-1 cursor-pointer me-2"
                            id="archive-grade" onChange={(e) => setArchiveGrade(e.target.checked ? 1 : 0)} />
                        <label htmlFor="archive-grade" className="cursor-pointer">Archive All 12th Grade Students?</label>
                    </>
                }
                isshow={showIncreseGradePopup}
                canceltext={"Cancel"}
                successtext={"Save"}
                successcall={(e) => IncreaseGradeByOne(e)}
                cancelcall={(e) => setShowIncreaseGradePopup(false)}
                btntype={'SaveBtn'} />
        </>
    )
}
